import React, { useState, useEffect } from 'react';

import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';

import Select from 'react-tailwindcss-select';

import { Link } from 'react-router-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import { useDispatch, useSelector } from 'react-redux';
import { getManagerList } from '../../../redux/actions/user/getManagerList';
import { useForm } from 'react-hook-form';
import Input from '../../Input/Input';
import { updateManagerVacancy } from '../../../redux/actions/dashborad/updateManagerVacancy';
import Loading from '../../Loading/Loading';
import { resetUpdateManagerVacancy } from '../../../redux/slices/dashboard.slice';
import { toast } from 'react-toastify';
import clsx from 'clsx';
import { setChatManager } from '../../../redux/actions/chat/setChatManager';
import { resetSetChatManager } from '../../../redux/slices/chat.slice';
import { usePermissions } from '../../../hooks/usePermissions';

export default function VacancyCellManager({ chatId, isSupport, editManger = true, size = 160, text = 'Менеджер', style, styleIcon, num, manager: managerPassed, styleSelect, styleSelectIcon = {} }) {
  const [manager, setManager] = useState(managerPassed);
  const [editManager, setEditManager] = useState(false);
  const { hasPermission } = usePermissions();
  const canManageVacancyManager = hasPermission('change_vacancy_manager');
  const canViewVacancyManager = canManageVacancyManager || hasPermission('view_vacancy_manager');
  const dispatch = useDispatch();
  const form = useForm();
  const managerInput = {
    type: 'search-select',
    required: false,
    name: 'manager_id',
    placeholder: 'Поиск менеджера',
    onSearch: (searchText, page) => {
      console.log(searchText);

      dispatch(getManagerList({ full_name: searchText, page, ...(!isSupport && { has_access_to_vacancy: num }) }));
    },
    actionName: 'getManagerList',
    sliceName: 'user',
    optionName: 'full_name',
  };
  const {
    updateManagerVacancy: { data: updateManagerVacancyData, error: updateManagerVacancyError, loading: updateManagerVacancyLoading },
  } = useSelector((state) => state.dashboard);
  const {
    setChatManager: { data: setChatManagerData, error: setChatManagerError, loading: setChatManagerLoading },
  } = useSelector((state) => state.chat);

  useEffect(() => {
    if (updateManagerVacancyData) {
      if (updateManagerVacancyData.id == num) {
        toast.success('Менеджер изменен');

        setEditManager(false);
        setManager(updateManagerVacancyData?.manager);
        form.setValue('savedManager', form.getValues('manager_id'));
        form.setValue('manager_id', null);
        dispatch(resetUpdateManagerVacancy());
      }
    }
  }, [updateManagerVacancyData]);

  useEffect(() => {
    if (setChatManagerData) {
      if (setChatManagerData.id == chatId) {
        toast.success('Менеджер изменен');

        setEditManager(false);
        setManager(setChatManagerData?.manager);
        form.setValue('savedManager', form.getValues('manager_id'));
        form.setValue('manager_id', null);
        dispatch(resetSetChatManager());
      }
    }
  }, [setChatManagerData]);

  React.useEffect(() => {
    const subscription = form.watch((value, { name, type }) => {
      if (name == 'manager_id' && value.manager_id) {
        if (isSupport) {
          dispatch(
            setChatManager({
              chatId,
              managerId: value.manager_id.value,
            }),
          );
        } else {
          dispatch(
            updateManagerVacancy({
              id: num,
              manager_id: value.manager_id.value,
            }),
          );
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [form.watch]);

  const savedManager = form.watch('savedManager');
  const managerName = savedManager?.label || manager?.full_name || manager?.name || manager?.label;
  const hasManager = Boolean(managerName);

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  return (
    <td className={clsx(`p-2 min-w-[${size}px] max-w-[${size}px] relative`, editManager && 'z-[100]')} onClick={(e) => e.stopPropagation()}>
      <OutsideClickHandler
        onOutsideClick={() => {
          if (!updateManagerVacancyLoading && !setChatManagerLoading) {
            setEditManager(false);
          }
        }}>
        {!canViewVacancyManager ? (
          <div className="px-3 py-2" style={{ ...style, ...styleSelect }} />
        ) : !canManageVacancyManager ? (
          <div className={clsx('px-3 py-2 text-sm whitespace-nowrap', hasManager ? 'text-gray-900' : 'text-gray-400')} style={{ ...style, ...styleSelect, maxWidth: '250px', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {hasManager ? managerName : 'Менеджера нет'}
          </div>
        ) : editManager ? (
          <>
            {' '}
            <Input form={form} {...managerInput} classNameWrap="scale-90 w-[110%] ml-[-5%]" />
            {(updateManagerVacancyLoading || setChatManagerLoading) && (
              <div className="absolute scale-75 w-[32px] h-[32px] right-4 top-1/2 -translate-y-1/2 bg-white">
                <Loading />
              </div>
            )}
          </>
        ) : manager || savedManager ? (
          <>
            {' '}
            <Menu as="div" className="relative inline-block text-left">
              <div>
                <Menu.Button className="inline-flex w-full justify-center border-0 gap-x-1.5 rounded-md  px-3 py-2 text-sm font-semibold text-gray-900 " style={{ ...styleSelect, whiteSpace: 'nowrap', maxWidth: '250px' }}>
                  <span style={{ display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{managerName}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" fill="currentColor" className="bi bi-caret-down-fill self-center" viewBox="0 0 16 16" style={{ ...styleSelectIcon, minWidth: '12px', minHeight: '12px' }}>
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"></path>
                  </svg>
                </Menu.Button>
              </div>

              <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                <Menu.Items className="absolute right-0 z-100 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" style={{ zIndex: 10 }}>
                  <div className="py-1">
                    <Menu.Item>
                      {({ active }) => (
                        <Link
                          onClick={() => {
                            if (isSupport) {
                              dispatch(
                                setChatManager({
                                  chatId,
                                  managerId: null,
                                }),
                              );
                            } else {
                              dispatch(
                                updateManagerVacancy({
                                  id: num,
                                  manager_id: null,
                                }),
                              );
                            }

                            form.setValue('manager_id', null);
                            form.setValue('savedManager', null);
                          }}
                          className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                          снять менеджера
                        </Link>
                      )}
                    </Menu.Item>

                    <Menu.Item>
                      {({ active }) => (
                        <Link to={`/edit/user/${savedManager ? savedManager.value : manager.id}`} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                          профиль менеджера
                        </Link>
                      )}
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          </>
        ) : (
          <div
            onClick={(e) => {
              e.stopPropagation();
              setEditManager(true);
            }}
            style={style}
            className={clsx('flex items-center select-none cursor-pointer text-sm hover:text-[#00B2A4] transition  px-3 py-2 relative z-1')}>
            {text}
            <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" className={clsx(' ml-[4px]')} style={styleIcon}>
              <path fill="currentColor" d="M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1"></path>
            </svg>
          </div>
        )}
      </OutsideClickHandler>

      {/* {manager?.name !== '' ? (
          <Menu as="div" className="relative inline-block text-left">
            <div>
              <Menu.Button className="inline-flex w-full justify-center border-0 gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900">
                {manager.name}
                <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" fill="currentColor" className="bi bi-caret-down-fill self-center" viewBox="0 0 16 16">
                  <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"></path>
                </svg>
              </Menu.Button>
            </div>

            <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
              <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        //    onClick={handleManagerChange}

                        name={num}
                        className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                        снять менеджера
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <Link to={`/editUser`} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                        профиль менеджера
                      </Link>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        ) : (
          <Select
            classNames={{
              menuButton: ({ isDisabled }) => `flex justify-between pr-1.5 py-1 text-gray-900 text-sm ${isDisabled ? 'bg-gray-200' : 'bg-white hover:border-gray-400'}`,
              menu: 'absolute z-10 w-full bg-white shadow-lg border-1 rounded text-sm text-gray-700',
              listItem: ({ isSelected }) => `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded ${isSelected ? `text-white bg-blue-500` : `text-gray-500 hover:bg-blue-100 hover:text-blue-500`}`,
              searchIcon: 'hidden ',
              searchBox: 'w-full text-sm text-gray-500 bg-gray-100 border border-gray-200 rounded focus:border-gray-200 focus:ring-0 focus:outline-none',
            }}
            placeholder="manager"
            value={manager.name}
            // onChange={handleChange}
            options={manager.options}
            isSearchable
          />
        )} */}
    </td>
  );
}
